






















































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import http from "@/axios/http-common";
import ResepObatSvc from "@/services/ResepObat";
import { storePasien } from "@/store/modules/pasien";
import { userModule } from "@/store/modules/user";
import moment from "moment";
import { resepStore } from "@/store/modules/resep";

@Component
export default class CardResepItems extends Vue {
  @Prop() resep_item: [];
  @Prop() resep!: any;
  @Prop() actionable = false;

  searchString = null;
  listResep = [];
  _timerId;

  get resepItems() {
    return this.resep_item;
  }

  get isResepTerjadwal() {
    return this.resep?.jenis_resep == 2;
  }

  get tampilkanEntry(): boolean {
    return !!this.resep?.entry_farmasi?.length;
  }

  jumlahEntry(item: { qty_entry?: number | null }): number {
    return item.qty_entry ?? 0;
  }

  kelasEntry(item: { qty?: number | string | null; qty_entry?: number | null }): string {
    return Number(item.qty_entry ?? 0) < Number(item.qty ?? 0) ? "red--text font-weight-bold" : "";
  }

  @Watch("searchString")
  searched() {
    this.listResep = [];
    clearTimeout(this._timerId);
    this._timerId = setTimeout(() => {
      if (this.searchString === null || this.searchString.length < 2) return;
      this.searchResep(this.searchString);
    }, 200);
  }

  searchResep(termSearch) {
    http
      .getDataParam(`/referensi/obat/search`, {
        params: { term: termSearch }
      })
      .then(res => {
        // console.log(res.data);
        this.listResep = res.data;
      })
      .finally();
  }
  changedResep(val) {
    console.log(val);
  }

  hapusResep(idx) {
    this.resep_item.splice(idx, 1);
    // this.resep?.items.splice(idx, 1);
  }

  stopItem(item) {
    const q = confirm("Anda yakin stop item obat ini?");

    console.log("item stop", item);

    const obatIds = item.r ? item.items.map(it => it.obat_id) : [item.obat_id];

    console.log("obatIds", obatIds);

    if (q) {
      ResepObatSvc.stopResepByObat({
        tanggal: moment(this.resep.tanggal).format("YYYY-MM-DD"),
        register_id: storePasien.registerPasien.register_id,
        obat_id: obatIds,
        dr_id: userModule.user.id.toString(),
        r: item.r
      }).then(resp => {
        if (resp.data.status) {
          item.stopped_at = moment().format("YYYY-MM-DD HH:mm:ss");
          item.items.map(
            it => (it.stopped_at = moment().format("YYYY-MM-DD HH:mm:ss"))
          );

          resepStore.getResepByRegister(storePasien.registerPasien.register_id);
        }
      });
    }
  }
}
